// Action types
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_LOADING = 'SET_USER_LOADING';
export const SET_BUILD_INFO = 'SET_BUILD_INFO';
export const SET_DAL_OPTIONS = 'SET_DAL_OPTIONS';
export const SET_STUDY_STATUS_OPTIONS = 'SET_STUDY_STATUS_OPTIONS';
export const SET_ORGANISM_OPTIONS = 'SET_ORGANISM_OPTIONS';
export const SET_ORGANIZATIONS_OPTIONS = 'SET_ORGANIZATIONS_OPTIONS';
export const SET_SPONSORS_OPTIONS = 'SET_SPONSORS_OPTIONS';
export const SET_DATA_TYPE_OPTIONS = 'SET_DATA_TYPE_OPTIONS';
export const SET_EXPOSURE_TYPE_OPTIONS = 'SET_EXPOSURE_TYPE_OPTIONS';
export const SET_TRUTH_DATA_OPTIONS = 'SET_TRUTH_DATA_OPTIONS';
export const SET_STUDY_SEARCH_QUERY = 'SET_STUDY_SEARCH_QUERY';
export const SET_STUDY_SEARCH_RESULTS = 'SET_STUDY_SEARCH_RESULTS';
export const SET_TAGS = 'SET_TAGS';
export const SET_MODEL_TYPES_OPTIONS = 'SET_MODEL_TYPES_OPTIONS';
export const SET_MODEL_EXPOSURE_TYPES_OPTIONS = 'SET_MODEL_EXPOSURE_TYPES_OPTIONS';
export const SET_PAGE_INFO = 'SET_PAGE_INFO';
export const SET_TOOLS_PAGE = 'SET_TOOLS_PAGE';
export const SET_FEATURE_COHORT = 'SET_FEATURE_COHORT';
export const SET_FEATURE_STUDYCARD = 'SET_FEATURE_STUDYCARD';
export const SET_FEATURE_ANALYST_WORKBENCH = 'SET_FEATURE_ANALYST_WORKBENCH';
export const SET_PAGE_LOADING = 'SET_PAGE_LOADING';
export const SET_THEME = 'SET_THEME';

export function setUserInfo(userInfo) {
  return { type: SET_USER_INFO, userInfo};
}

export function setUserLoading(userLoading) {
  return { type: SET_USER_LOADING, userLoading};
}

export function setBuildInfo(buildInfo) {
  return { type: SET_BUILD_INFO, buildInfo};
}

export function setDataAccessLevelOptions(options) {
  return { type: SET_DAL_OPTIONS, options};
}

export function setStudyStatusOptions(options) {
  return { type: SET_STUDY_STATUS_OPTIONS, options};
}

export function setOrganismOptions(options) {
  return { type: SET_ORGANISM_OPTIONS, options};
}

export function setOrganizationsOptions(options) {
  return { type: SET_ORGANIZATIONS_OPTIONS, options};
}

export function setSponsorsOptions(options) {
  return { type: SET_SPONSORS_OPTIONS, options};
}

export function setDataTypeOptions(options) {
  return { type: SET_DATA_TYPE_OPTIONS, options};
}

export function setExposureTypeOptions(options) {
  return { type: SET_EXPOSURE_TYPE_OPTIONS, options};
}

export function setTruthDataOptions(options) {
  return { type: SET_TRUTH_DATA_OPTIONS, options};
}

export function setStudySearchQuery(query) {
  return { type: SET_STUDY_SEARCH_QUERY, query};
}

export function setStudySearchResults(results) {
  return { type: SET_STUDY_SEARCH_RESULTS, results};
}

export function setTags(tags) {
  return { type: SET_TAGS, tags};
}

export function setModelTypesOptions(options) {
  return { type: SET_MODEL_TYPES_OPTIONS, options};
}

export function setModelExposureTypesOptions(options) {
  return { type: SET_MODEL_EXPOSURE_TYPES_OPTIONS, options};
}

export function setPageInfo(pages) {
  return { type: SET_PAGE_INFO, pages}
}

export function setPageTools(toolsPage) {
  return { type: SET_TOOLS_PAGE, toolsPage}
}

export function setFeatureCohort(feature_cohort) {
  return { type: SET_FEATURE_COHORT, feature_cohort}
}

export function setFeatureStudyCard(feature_studycard) {
  return { type: SET_FEATURE_STUDYCARD, feature_studycard}
}

export function setFeatureAnalystWorkbench(feature_aw) {
  return { type: SET_FEATURE_ANALYST_WORKBENCH, feature_aw}
}

export function setPageLoading(pageLoading) {
  return { type: SET_PAGE_LOADING, pageLoading};
}

export function setTheme(theme) {
  return { type: SET_THEME, theme};
}
